<template>
    <div>
        <div v-if="hasPromoMaintenance()">
            <div class="details-panel__body promoOffer">
                <h2>{{ getTranslation('promo2025', 'maintenance_banner_tittle', {product_name: maintenanceProductName()}) }}</h2>
                <div class="row">
                    <div class="col-md-9 col-sm-12">
                        <p>
                            {{ getTranslation('promo2025', 'maintenance_banner_sub') }}
                        </p>
                        <br>
                        <div v-html="getTranslation('promo2025', 'maintenance_banner_text', {product_name: maintenanceProductName()}) "></div>
                    </div>
                    <div class="col-md-3 col-sm-12 text-center">
                        <a href="javascript:;" @click="toggleMaintenance()" class="btn btn-order promoButton2025" style="display:none;">
                            {{ getTranslation('promo2025', 'maintenance_banner_button') }}
                        </a>
                        <br><br>
                        <a class="moreInfo" @click="toggleMoreInfoPromo('bv-modal-promoMaintenance')" href="javascript:;">
                            {{ getTranslation('promo2025', 'maintenance_banner_small_text') }}
                        </a>
                    </div>
                </div>
            </div>

            <b-modal id="bv-modal-promoMaintenance" size="xl" centered hide-footer>
                <template #modal-title>
                    <div class="modal-title__icon">
                        <svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" ><path fill="currentColor" d="M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-11.49 120h22.979c6.823 0 12.274 5.682 11.99 12.5l-7 168c-.268 6.428-5.556 11.5-11.99 11.5h-8.979c-6.433 0-11.722-5.073-11.99-11.5l-7-168c-.283-6.818 5.167-12.5 11.99-12.5zM256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28z"></path>
                        </svg>
                    </div>
                    <span>
                     {{ getTranslation('promo2025', 'maintenance_popup_title', {product_name: maintenanceProductName()}) }}
                </span>
                </template>
                <div class="d-block">
                    <div v-html="getTranslation('promo2025', 'maintenance_popup_text', {product_name: maintenanceProductName()})"></div>

                </div>
                <div class="text-center">
                    <b-button class="mt-3 mx-auto"  @click="closeModal('bv-modal-promoMaintenance')">{{ getTranslation('front', 'close') }}</b-button>
                </div>
            </b-modal>
        </div>
        <div v-if="hasPromoLease()">
            <div class="details-panel__body promoOffer">
                <h2>
                    {{ getTranslation('promo2025', '6_months_banner_tittle', {product_name: leaseProductName()}) }}
                </h2>
                <div class="row">
                    <div class="col-md-9 col-sm-12">

                        <p>{{ getTranslation('promo2025', '6_months_banner_sub') }}</p>
                        <br>
                        <div v-html="getTranslation('promo2025', '6_months_banner_text', {product_name: leaseProductName()})"> </div>
                    </div>
                    <div class="col-md-3 col-sm-12 text-center">
                        <a href="javascript:;" @click="togglePromo('bv-modal-promoLease')" class="btn btn-order promoButton2025">{{ getTranslation('promo2025', '6_months_banner_button') }}</a>
                        <br><br>
                        <a class="moreInfo" @click="toggleMoreInfoPromo('bv-modal-promoLease')" href="javascript:;">{{ getTranslation('promo2025', '6_months_banner_small_text') }}</a>
                    </div>
                </div>
            </div>

            <b-modal id="bv-modal-promoLease" size="xl" centered hide-footer>
                <template #modal-title>
                    <div class="modal-title__icon">
                        <svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" ><path fill="currentColor" d="M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-11.49 120h22.979c6.823 0 12.274 5.682 11.99 12.5l-7 168c-.268 6.428-5.556 11.5-11.99 11.5h-8.979c-6.433 0-11.722-5.073-11.99-11.5l-7-168c-.283-6.818 5.167-12.5 11.99-12.5zM256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28z"></path>
                        </svg>
                    </div>
                    <span>
                     {{ getTranslation('promo2025', '6_months_popup_title', {product_name: leaseProductName()}) }}
                </span>
                </template>
                <div class="d-block">
                    <div v-html="getTranslation('promo2025', '6_months_popup_text', {product_name: leaseProductName(), program_info: leaseProgramInfo()})">

                    </div>
                </div>
                <div class="text-center">
                    <b-button class="mt-3 mx-auto"  @click="closeModal('bv-modal-promoLease')">{{ getTranslation('front', 'close') }}</b-button>
                </div>
            </b-modal>
        </div>
    </div>

</template>

<script>
    export default {
        methods: {
            hasPromoLease() {
                if (_.isNil(this.promoLease)) {
                    return false;
                }
                if (_.isEmpty(this.promoLease)) {
                    return false;
                }
                return true;
            },
            hasPromoMaintenance() {
                return this.promoMaintenance;
            },
            toggleMaintenance() {
                if (this.$store.state.cart.maintenance[this.promoMaintenance].status != true) {
                    this.$store.commit('toggleMaintenance', {
                        product: this.promoMaintenance,
                        price: this.totalMaintenance()
                    });
                }

                if (this.$store.state.cart.cartStep < 2) {
                    let payload = {'step': 3};
                    this.$store.commit('setCartStep', payload);
                }
                window.location.href = this.navigation.user_info;
            },
            totalMaintenance() {
                let total = 0;

                if (!_.isNil(this.$store.state.cart.maintenance[this.promoMaintenance])) {
                    if (this.$store.state.cart.maintenance[this.promoMaintenance].status == true) {
                        total = this.getProductMaintenancePrice(this.promoMaintenance);
                    }
                }

                return total;
            },

            togglePromo() {
                this.emptyCart();
                let promoPrograms = this.promoProgramsInfo();
                let payload = {
                    product: this.promoProduct,
                    status: true,
                    info: promoPrograms,
                }
                this.$store.commit('addPromoLease', payload);
                if (this.$store.state.cart.cartStep < 2) {
                    let payload = {'step': 3};
                    this.$store.commit('setCartStep', payload);
                }
                window.location.href = this.navigation.user_info;
            },
            promoProgramsInfo() {
                if (!this.hasPromoLease()) {
                    return false;
                }

                let programs = this.products[this.promoProduct]['items'];
                let promoPrograms = [];

                _.forEach(this.promoLease[this.promoProduct]['items'], function (qty, key) {
                    let program = _.find(programs, function(pr) {
                        return pr.id == key;
                    });
                    let info = {
                        id: program.id,
                        name: program.name,
                        qty: qty
                    };
                    promoPrograms.push(info);
                });
                return promoPrograms;
            },
            leaseProgramInfo() {
                let text = '';
                _.forEach(this.promoProgramsInfo(), function (item) {
                    text += '<li>x' + item.qty + '  ' + item.name + '</li>';
                })
                return text;
            },
            emptyCart() {
                let self = this;
                _.forEach(this.products, function (p, key) {
                    if (!_.isNil(self.$store.state.cart.maintenance[p.id])) {
                        let payload = {
                            product: p.id,
                            status: false,
                            price: 0,
                        }
                        self.$store.commit('toggleMaintenance', payload);
                    }
                    if (!_.isNil(self.$store.state.cart.singleUpgrade[p.id])) {
                        self.$root.$emit("toggleProductCart", {product: p.id, status:false});
                        self.$store.state.cart.singleUpgrade[p.id].info.forEach(function(l, index) {
                            self.$store.commit('toggleSingleUpgradeProgram', {
                                product: p.id,
                                index: index
                            });

                        });
                    }
                });
                if (!_.isNil(this.$store.state.cart.programs)) {
                    this.$store.state.cart.programs.forEach(function(p, index) {
                        self.$store.commit('removeFromCart', {item: p});
                    });
                }
            },

            toggleMoreInfoPromo(modal) {
                this.$bvModal.show(modal)
            },
            closeModal(modal) {
                this.$bvModal.hide(modal)
            },
            maintenanceProductName() {
                let self = this;
                let name = 'GEO5';
                _.forEach(this.products, function (p, key) {
                    if (p.id == self.promoMaintenance) {
                        name = p.name;
                    }
                });
                return name;
            },
            leaseProductName() {
                let self = this;
                let name = 'GEO5';
                _.forEach(this.products, function (p, key) {
                    if (p.id == self.promoProduct) {
                        name = p.name;
                    }
                });
                return name;
            }
        },
        mounted() {

        },
        computed: {
            promoProduct() {
                let self = this;
                let pid = false
                _.forEach(this.products, function (p, key) {
                    if (
                        !_.isNil(self.promoLease) &&
                        !_.isNil(self.promoLease[key]) &&
                        self.promoLease[key].hasLease
                    ) {
                        pid = key;
                        return false;
                    }
                });
                return pid;
            },
        },
        data() {
            return {
                promoLease: JSON.parse(window.promoLease),
                promoMaintenance: JSON.parse(window.promoMaintenance),
                products: window.jsonProducts,
                navigation: window.quickNavigationUrls,
            };
        }
    }
</script>


<style>
.promoOffer {
    border: solid 1px #fda5a5;
    background-color: #fdfdbc;
    padding: 20px;
    margin-bottom: 40px;
}
.moreInfo, .moreInfo:hover {
    color: gray;
}
.promoButton2025 {
    margin-top: 20px;
}
</style>
